import { BaseService, QueryParams } from "./BaseService";
import type {
  SectionItemInput,
  SectionItemOutput,
} from "@/interfaces/section-items";

export class SectionItemsService extends BaseService<
  SectionItemInput,
  SectionItemOutput
> {
  constructor() {
    super();
    this.path = "section_items";
  }

  async findBySectionId(
    sectionId: string,
    queryParams?: QueryParams
  ): Promise<SectionItemOutput[]> {
    const url = `sections/${sectionId}/items`;
    const response = await this.request<SectionItemOutput[]>(url, {
      method: "GET",
      queryParams,
    });

    return response;
  }
}
